import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import DOMPurify from 'dompurify';

@Component({
  selector: 'app-confirm-box',
  templateUrl: './confirm-box.component.html',
})
export class ConfirmBoxComponent {
  @Input() title: string | undefined;
  @Input() message: string | undefined;
  purify = DOMPurify.sanitize;
  
  constructor(private activeModal: NgbActiveModal) { };

  confirm(): void {
    this.activeModal.close(true);
  }

  reject(): void {
    this.activeModal.close(false);
  }
}